import { render, staticRenderFns } from "./properties-header.vue?vue&type=template&id=ec7285a6&scoped=true"
import script from "./properties-header.vue?vue&type=script&lang=js"
export * from "./properties-header.vue?vue&type=script&lang=js"
import style0 from "./properties-header.vue?vue&type=style&index=0&id=ec7285a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7285a6",
  null
  
)

export default component.exports